export default {
  state: {
    baseInfo: ''
  },
  mutations: {

  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/basicInfo.js